import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const RightSidebar = () => {
  const { t } = useTranslation();
  const storedUserId = localStorage.getItem("userId");
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!storedUserId) return;
    const fetchVacancies = async () => {
      try {
        const res = await fetch(
          `/api/company_vacancies.php?id=${storedUserId}`
        );
        const data = await res.json();
        if (data.success && data.vacancies) {
          setVacancies(data.vacancies);
        }
      } catch (err) {
        console.error("Error fetching vacancies:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVacancies();
  }, [storedUserId]);

  return (
    <aside className="w-full z-10 opacity-0 animate-[showtitle_1s_forwards]">
      <ul className="space-y-3">
        <li>
          <Link
            to="/EditCompanyPage"
            className="block shadow px-3 py-2 bg-gray-200 rounded-lg hover:bg-white transition-all duration-200"
          >
            {t("companypage")}
          </Link>
        </li>

        <li>
          <Link
            to={`/ViewCompanyVacancies/${storedUserId}`}
            className="block shadow px-3 py-2 bg-gray-200 rounded-lg hover:bg-white transition-all duration-200"
          >
            {t("My Job Posts")}
          </Link>
        </li>

        <li>
          <Link
            to={`/MyNews/${storedUserId}`}
            className="block shadow px-3 py-2 bg-gray-200 rounded-lg hover:bg-white transition-all duration-200"
          >
            {t("My News")}
          </Link>
        </li>

        <li>
          <Link to='/LikedCandidates'
            href="#"
            className="block shadow px-3 py-2 bg-gray-200 rounded-lg hover:bg-white transition-all duration-200"
          >
            {t("Candidates")}
          </Link>
        </li>

        <li>
          <Link to='/Notifications'
            href="#"
            className="block shadow px-3 py-2 bg-gray-200 rounded-lg hover:bg-white transition-all duration-200"
          >
            {t("Notifications")}
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default RightSidebar;
